



















































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { RegistrationPayload } from "../../models/auth.model";
import FacebookLoginButton from "@/components/FacebookLoginButton.vue";
import GoogleLoginButton from "@/components/GoogleLoginButton.vue";
import { FormCheckboxPlugin, FormGroupPlugin, FormInputPlugin, FormPlugin, ButtonPlugin, SpinnerPlugin } from "bootstrap-vue";
import Vuelidate from "vuelidate";
import { required, sameAs, email, minLength, maxLength } from "vuelidate/lib/validators";
import { AuthActionTypes, namespaceAuth } from "../../store/auth";

Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ButtonPlugin);
Vue.use(SpinnerPlugin);
Vue.use(Vuelidate);

@Component({
  name: "RegistrationPage",
  components: { FacebookLoginButton, GoogleLoginButton },
  data() {
    return {
      form: {
        username: "",
        first_name: "",
        last_name: "",
        phone: "",
        birth_date: "",
        email: "",
        mother_name: "",
        password: "",
        password_confirmation: "",
        terms: false,
        privacy: false
      },
      isLoading: false
    };
  },
  validations: {
    form: {
      username: {
        required
      },
      first_name: {
        required
      },
      last_name: {
        required
      },
      phone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(11)
      },
      mother_name: {
        required
      },
      birth_date: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      },
      password_confirmation: {
        sameAs: sameAs("password"),
        required
      },
      terms: {
        sameAs: sameAs(() => true)
      },
      privacy: {
        sameAs: sameAs(() => true)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]!;
      return $dirty ? !$error : null;
    }
  }
})
export default class RegistrationPage extends Vue {
  form!: RegistrationPayload;
  isLoading!: boolean;

  async onSubmit(event: Event) {
    event.preventDefault();

    if (this.$v.$invalid) {
      this.$v.$touch();
    } else {
      this.isLoading = true;
      await this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.Registration}`, this.form);
      this.isLoading = false;
    }
  }
}
